import { FC } from 'react';
import { Tooltip } from '@mui/material';
import { ZOOM_AUTO_HINWEIS, istZoomAutomatik } from '@/constants/outcomeOptions';
import StatusTag from './StatusTag';

interface ZoomAutoBadgeProps {
  /** `meetings.outcome_source` — nur `zoom_auto` erzeugt eine Kennzeichnung. */
  source?: string | null;
}

/**
 * Kennzeichnung automatisch vergebener Ergebnisse (Auftrag Alex 09.08.2026,
 * Punkt 2; angelegt im Nachtrag vom 02.08. zu
 * docs/tasks/zoom-ergebnis-automatik.md).
 *
 * Warum ueberhaupt: Seit der Scharfschaltung setzt die Zoom-Automatik
 * Ergebnisse auf Termine, die niemand bewertet hat. Ohne Kennzeichnung ist
 * ein solcher Eintrag von einer VP-Eingabe nicht zu unterscheiden — und weil
 * er zusaetzlich gesperrt ist (Punkt 3), stuende der VP sonst vor einem
 * Feld, das sich grundlos nicht bedienen laesst.
 *
 * Bewusst ueber `StatusTag`: kein Hex-Wert an dieser Stelle (CLAUDE.md §5)
 * und dieselbe Pillenform wie jede andere Kennzeichnung im Haus. Bewusst
 * `gray`: die Herkunft ist eine Randnotiz, kein Alarm — „dezent" ist die
 * Vorgabe.
 *
 * `null`/`undefined` heisst „Herkunft unbekannt" (Alt-Bestand vor Einfuehrung
 * der Spalte) und wird NICHT gekennzeichnet: ein Badge waere dort eine
 * Behauptung ueber Daten, die wir nicht haben.
 */
const ZoomAutoBadge: FC<ZoomAutoBadgeProps> = ({ source }) => {
  if (!istZoomAutomatik(source)) return null;

  return (
    <Tooltip title={ZOOM_AUTO_HINWEIS}>
      {/* span: Tooltip braucht ein Element, das Ref und Events annimmt.
          Das aria-label sitzt hier und nicht am StatusTag, damit der Grund
          auch ohne Hover (Screenreader, Tastatur) ankommt — ein reiner
          Tooltip auf dem Buchstaben „Z" waere sonst stumm. */}
      <span aria-label={ZOOM_AUTO_HINWEIS}>
        <StatusTag label="Z" variant="gray" />
      </span>
    </Tooltip>
  );
};

export default ZoomAutoBadge;
